import "es6-promise/auto";

//css assets



export default {
 
}
